import "../../styles/product-detail.css";
import Footer from "../../components/footer";
import Header from "../../components/header";

function BrandCollect() {
  return (
    <div>
      <Header />
      <div className="product-details">
        <div className="details-heading">
          <h1>BrandCollect</h1>
          <p>Developed by our team of professionals.</p>
        </div>
        <div className="details-body">
          <p>
            BrandCollect is a web based service that facilitates real-time
            collection of payments for ministries, departments and agencies
            (MDAs) of government. The service provides a web form and a payment
            gateway for web payment and bank branch payment of government fees,
            levies and other statutory payments. Revenues are collected and
            accounted for using the service. It comes with API libraries that
            interfaces with the Legacy application of MDA.
          </p>
          <p>
            The service is used for the issuance of statutory Approvals, Permits
            and Licenses as may be required.
          </p>
          <p>
            It eliminates the need for physical presence at the MDA to purchase
            or pick or submit forms. The stress and cost of moving to and from
            the MDA's office virtually eliminated. It enhances ease of doing
            business in any MDA that deploys it.
          </p>
        </div>
        <div className="details-features">
          <p>
            This service is currently being used by{" "}
            <span>
              The Nigerian Midstream and Downstream Petroleum Regulatory
              Authority (NMDPRA)
            </span>{" "}
            for the following Permits and Licenses:
          </p>
          <ol>
            <li>
              <p>Oil and Gas Industry Service Permit (OGISP)</p>
            </li>
            <li>
              <p>Online Application of Category ABC (ROMS Portal)</p>
            </li>
            <li>
              <p>Coastal Vessel License</p>
            </li>
            <li>
              <p>Depot License</p>
            </li>
            <li>
              <p>Liquified Gas Plant, Depots, and CNGs</p>
            </li>
          </ol>
        </div>
        <div className="details-body">
          <p>These are just a few...</p>
        </div>
        <p className="details-cta">Request for demo and proposal today…</p>
      </div>
      <Footer />
    </div>
  );
}

export default BrandCollect;
